export default "__VITE_ASSET__D47H6ZFW__"